import { HIDE_LOADER, LoadingSpinnerAction, SHOW_LOADER } from '../selectors/loading-spinner-selector';

export const initialLoaderState = (): LoadingSpinnerState => ({
  loading: false,
});

export interface LoadingSpinnerState {
  loading: boolean;
}

const loaderReducer = (
  state: LoadingSpinnerState = initialLoaderState(),
  action: LoadingSpinnerAction = { type: HIDE_LOADER }
) => {
  switch (action.type) {
    case SHOW_LOADER:
      return { ...state, loading: true };
    case HIDE_LOADER:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default loaderReducer;
